import script from "./HeaderAzvmsv.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderAzvmsv.vue?vue&type=script&setup=true&lang=js"

import "./HeaderAzvmsv.vue?vue&type=style&index=0&id=c5b574e8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5b574e8"]])

export default __exports__